import type { InjectionKey } from "vue";

export const openAlertPaywallModalKey = Symbol() as InjectionKey<() => void>;
export const openDigestPaywallModalKey = Symbol() as InjectionKey<() => void>;
export const openDashboardPaywallModalKey = Symbol() as InjectionKey<
  () => void
>;
